import "./simple-data-table.scss";
import $ from "jquery";
import get from "lodash/get";
window.$ = window.jQuery = $;

window.app.directive("bindHtmlCompile", [
  "$compile",
  function($compile) {
    return {
      restrict: "A",
      link: function(scope, element, attrs) {
        scope.$watch(
          function() {
            return scope.$eval(attrs.bindHtmlCompile);
          },
          function(value) {
            // Incase value is a TrustedValueHolderType, sometimes it
            // needs to be explicitly called into a string in order to
            // get the HTML string.
            element.html(value && value.toString());
            // If scope is provided use it, otherwise use parent scope
            var compileScope = scope;
            if (attrs.bindHtmlScope) {
              compileScope = scope.$eval(attrs.bindHtmlScope);
            }
            $compile(element.contents())(compileScope);
          }
        );
      }
    };
  }
]);

window.app.directive("simpleDataTable", [
  function() {
    return {
      restrict: "E",
      scope: {
        rows: "&",
        columns: "&",
        emptyMsg: "@",
        emptyClass: "@",
        onRowClick: "&",
        sort: "="
      },
      template: (tElement, tAttrs) => {
        tElement.html(require("./simple-data-table.html"));
      },
      controller: [
        "$scope",
        "$attrs",
        function($scope, $attrs) {
          $scope.clickable = !!$attrs.onRowClick;
          $scope.ext = $scope.$parent;
          $scope.empty = () => {
            const rows = $scope.rows();
            return !rows || !rows.length;
          };
          $scope.innerOnRowClick = (row, index) => {
            $scope.onRowClick({ $row: row, $index: index });
          };

          $scope.sorting = $scope.sort || {};

          $scope.onHeaderClick = col => {
            if (col.sortable === false) return;
            if (!$scope.sorting.path || $scope.sorting.path !== col.key) {
              $scope.sorting = { path: col.key, dir: 1 };
            } else {
              if ($scope.sorting.dir === 1) {
                $scope.sorting.dir = -1;
              } else {
                $scope.sorting.path = null;
              }
            }
          };

          const getComparator = cfg => (a, b) => {
            const aVal = get(a, cfg.path);
            const bVal = get(b, cfg.path);
            return cfg.dir * genericComp(aVal, bVal);
          };

          const genericComp = (a, b) => {
            if (a === b) {
              return 0;
            } else if (a > b) {
              return 1;
            } else {
              return -1;
            }
          };

          $scope.getColStyle = col => {
            const styles = [];
            if (col.width) styles.push(`width: ${col.width}`);
            if (col.minWidth) styles.push(`min-width: ${col.minWidth}`);
            if (col.maxWidth) styles.push(`max-width: ${col.maxWidth}`);
            return styles.join(";");
          };

          $scope.getSortClass = col => {
            if (
              col.sortable === false ||
              !$scope.sorting.path ||
              $scope.sorting.path !== col.key
            ) {
              return "none";
            } else {
              return $scope.sorting.dir === 1 ? "asc" : "desc";
            }
          };

          $scope.getCellContents = (row, col) => {
            const html = col.formatter
              ? col.formatter(row[col.key], row)
              : row[col.key];
            return html; //utils.getSanitizedHTML(html || "");
          };

          $scope.getHeader = col => {
            const html =
              typeof col.title === "function"
                ? col.title()
                : col.title || col.key;
            return html; //utils.getSanitizedHTML(html);
          };

          $scope.getRows = () =>
            $scope.sorting.path
              ? $scope
                  .rows()
                  .slice()
                  .sort(getComparator($scope.sorting))
              : $scope.rows();
        }
      ]
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/simple-data-table/simple-data-table.js